module.exports = __webpack_public_path__ + "static/media/T-warning.509f84ec.svg";